"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var column_type_1 = require("@synisys/idm-portfolio-control/app/controls/model/column-type");
var router_1 = require("@angular/router");
var entity_form_resolver_service_1 = require("@synisys/idm-portfolio-control/app/controls/portfolio/entity-form-resolver.service");
var pending_item_type_1 = require("../model/pending-item-type");
var overdue_warning_service_1 = require("../../../shared/services/api/overdue-warning.service");
var pending_action_settings_service_1 = require("../../../shared/services/api/pending-action-settings.service");
var operators_1 = require("rxjs/operators");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_workflow_service_client_js_1 = require("@synisys/idm-workflow-service-client-js");
var pending_action_portfolio_helper_service_1 = require("../service/pending-action-portfolio-helper.service");
var pending_action_portfolio_form_resolver_service_1 = require("../service/pending-action-portfolio-form-resolver.service");
var dynamic_navigation_helper_1 = require("../../summary-pages/common/utils/dynamic-navigation-helper");
var pending_action_helper_service_1 = require("../service/pending-action-helper.service");
var PendingActionPortfolioComponent = /** @class */ (function () {
    function PendingActionPortfolioComponent(route, router, cdRef, overdueWarningService, pendingActionSettingsService, kbService, processService, pendingActionPortfolioHelperService) {
        var _a;
        this.route = route;
        this.router = router;
        this.cdRef = cdRef;
        this.overdueWarningService = overdueWarningService;
        this.pendingActionSettingsService = pendingActionSettingsService;
        this.kbService = kbService;
        this.processService = processService;
        this.pendingActionPortfolioHelperService = pendingActionPortfolioHelperService;
        this.pendingTypeMessage = (_a = {},
            _a[pending_item_type_1.PendingItemType.DRAFT] = 'ejustice_pending_draft',
            _a[pending_item_type_1.PendingItemType.OVERDUE] = 'ejustice_pending_overdue',
            _a[pending_item_type_1.PendingItemType.PENDING_REACTION] = 'ejustice_pending_reaction',
            _a[pending_item_type_1.PendingItemType.PENDING_ACTION] = 'ejustice_pending_action',
            _a);
        this.replaySubjects = [];
    }
    PendingActionPortfolioComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.pendingItemType = dynamic_navigation_helper_1.getPropertyFromUrl('pendingItemType', this.route);
        this.categoryId = dynamic_navigation_helper_1.getPropertyFromUrl('categoryId', this.route);
        this.portfolioConfig$ =
            this.pendingActionSettingsService.loadPendingActionSettingByCategory(this.categoryId)
                .pipe(operators_1.tap(function (pendingActionCategorySetting) { return _this.pendingActionCategorySetting = pendingActionCategorySetting; }), operators_1.switchMap(function (pendingActionCategorySetting) {
                return _this.pendingActionPortfolioHelperService.constructPendingPortfolio(_this.pendingItemType, pendingActionCategorySetting)
                    .pipe(operators_1.tap(function (configs) {
                    if (configs.externalFilters) {
                        configs.externalFilters = { '$and': ['${hasWFAction}', configs.externalFilters] };
                    }
                    else {
                        configs.externalFilters = pending_action_helper_service_1.PendingActionHelperService.externalFilter;
                    }
                    if (_this.pendingItemType === pending_item_type_1.PendingItemType.DRAFT && configs.quickFilter && configs.quickFilter._filterSystemName === 'WFStateID') {
                        configs.quickFilter = null;
                    }
                    configs.portfolioConfig.columns.filter(function (column) { return column.columnType === column_type_1.ColumnType.TEMPLATE; })
                        .forEach(function (templateColumn) {
                        _this.replaySubjects.push(templateColumn.template$);
                    });
                    _this.cdRef.detectChanges();
                    _this.afterFieldsInit();
                }));
            }));
    };
    PendingActionPortfolioComponent.prototype.afterFieldsInit = function () {
        var _this = this;
        this.replaySubjects.forEach(function (replaySubject, index) {
            replaySubject.next(_this.viewContainerRefs.toArray()[index]['_data']['template']);
        });
    };
    __decorate([
        core_1.ViewChildren('customComponentContainer', { read: core_1.ViewContainerRef }),
        __metadata("design:type", core_1.QueryList)
    ], PendingActionPortfolioComponent.prototype, "viewContainerRefs", void 0);
    PendingActionPortfolioComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-pending-action-portfolio',
            styles: [require('./pending-action-portfolio.component.css')],
            template: require('./pending-action-portfolio.component.html'),
            providers: [{ provide: entity_form_resolver_service_1.EntityFormResolverService, useClass: pending_action_portfolio_form_resolver_service_1.PendingActionPortfolioFormResolverService }]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute,
            router_1.Router,
            core_1.ChangeDetectorRef,
            overdue_warning_service_1.OverdueWarningService,
            pending_action_settings_service_1.PendingActionSettingsService,
            idm_kb_service_client_js_1.KbService,
            idm_workflow_service_client_js_1.ProcessService,
            pending_action_portfolio_helper_service_1.PendingActionPortfolioHelperService])
    ], PendingActionPortfolioComponent);
    return PendingActionPortfolioComponent;
}());
exports.PendingActionPortfolioComponent = PendingActionPortfolioComponent;
//# sourceMappingURL=pending-action-portfolio.component.js.map